import React, { Component } from 'react';
import Head from 'next/head';
import Image from 'next/image';

import solution1 from '../public/images/google-s-1.png';
import solution2 from '../public/images/google-s-2.png';
import solution3 from '../public/images/google-s-3.png';
import solution4 from '../public/images/google-s-4.png';
import solution5 from '../public/images/google-s-5.png';
import solution6 from '../public/images/google-s-6.png';

const solutions = [
  {
    image: solution1,
    des: '搜索广告快速、精准的找到潜在客户，提高ROI。',
  },
  {
    image: solution2,
    des: '展示广告将大量用户引流至目标网站，实现品牌曝光，提高品牌知名度。',
  },
  {
    image: solution3,
    des: '再营销广告抓取网站流失客户，鼓励用户再次访问网站，进行购买。',
  },
  {
    image: solution4,
    des: '购物PLA广告，将产品和价格直观的展示给用户，方便用户快速进行购买。',
  },
  {
    image: solution5,
    des: '利用YouTube TrueView 视频广告分享品牌故事，覆盖合适的受众群体。',
  },
  {
    image: solution6,
    des: '使用AdMob 移动应用安装广告，促使用户下载应用，促进应用内消费。',
  },
];

class Google extends Component {
  render() {
    return (
      <>
        <Head>
          <meta
            name="keywords"
            content="Google广告投放，海外推广，Google推广，Google代理，Google开户"
          />
          <meta
            name="description"
            content="Hidream讯梦国际是Google核心合作伙伴、一级代理商，为出海企业提供Google开户，Google广告投放，YouTube视频制作，Google营销推广等一站式海外营销解决方案。"
          />
        </Head>

        <div id="Google">
          <div className="banner">
            <Image
              src={require('../public/images/banner-4.png').default}
              alt="google-banner"
              layout="responsive"
            />
          </div>

          <div className="google-summary bb">
            <div className="content">
              <div className="p-1">
                <p>
                  Google是全球最大的搜索引擎，占据了海外近90%的搜索流量。拥有全球第一大视频网络Youtube。
                </p>
              </div>

              <div className="p-2">
                <p>
                  提供世界第一大邮箱服务Gmail，Google
                  Ads在线广告营销平台，整合Google旗下各平台资源，已帮助全球成千上万的商家提升了业绩。
                </p>
              </div>
            </div>
          </div>

          <div className="google-products">
            <div className="header">
              <div className="inner-header-3">
                <h3>Google广告产品体系全方位覆盖目标人群</h3>
                <p>
                  Google advertising product system covers all target groups
                </p>
              </div>
            </div>

            <div className="inner-content bb">
              <ul className="row">
                <li className="col">
                  <Image
                    className="top"
                    src={
                      require('../public/images/google-搜索广告.png').default
                    }
                    alt="搜索广告"
                    layout="responsive"
                  />

                  <div className="bottom">
                    <h3 className="title-1">搜索广告</h3>
                    <p className="des">
                      您的广告会显示在Google搜索结果旁边。精准捕捉关键时刻，绝不错过展示良机。
                    </p>
                    <div className="title-2">搜索引擎</div>
                  </div>
                </li>
                <li className="col">
                  <Image
                    className="top"
                    src={
                      require('../public/images/google-展示广告.png').default
                    }
                    alt="展示广告"
                    layout="responsive"
                  />

                  <div className="bottom">
                    <h3 className="title-1">展示广告</h3>
                    <p className="des">
                      文字广告和横幅广告可展示在Gmail上，更可显示由200万个网站和应用构成的庞大网络上，随处精准定位客户。
                    </p>
                    <div className="title-2">展示广告联盟</div>
                  </div>
                </li>
                <li className="col">
                  <Image
                    className="top"
                    src={
                      require('../public/images/google-视频广告.png').default
                    }
                    alt="视频广告"
                    layout="responsive"
                  />

                  <div className="bottom">
                    <h3 className="title-1">视频广告</h3>
                    <p className="des">
                      向YouTube上的新客户生动展示您的业务。以独特方式分享您的故事。
                    </p>
                    <div className="title-2">视频平台</div>
                  </div>
                </li>
                <li className="col">
                  <Image
                    className="top"
                    src={
                      require('../public/images/google-应用广告.png').default
                    }
                    alt="应用广告"
                    layout="responsive"
                  />

                  <div className="bottom">
                    <h3 className="title-1">应用广告</h3>
                    <p className="des">
                      在整个Google网络上投放广告，无需设计经验，即可轻松宣传您的应用。
                    </p>
                    <div className="title-2">移动平台</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className="google-solutions bb">
            <div className="header">
              <div className="inner-header-3">
                <h3>Google Ads-营销解决方案</h3>
                <p>Google Ads-Marketing Solutions</p>
              </div>
            </div>

            <div className="inner-content">
              <ul className="row">
                {solutions.map((item, index) => {
                  return (
                    <li className="col" key={index + 1}>
                      <div className="index">0{index + 1}.</div>
                      <Image src={item.image} alt={item.alt} />
                      <p>{item.des}</p>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Google;
